import { Button } from '@sunwebgroup/uds-ui/button'
import { Icon, type IconGlyph } from '@sunwebgroup/uds-ui/icon'
import { Typography } from '@sunwebgroup/uds-ui/typography'
import { useIntl } from '@/intl'
import { useBookingDetailsActions } from '@/scopes/account/booking-details/infrastructure/dependencies/dependencies'
import styles from './PartialCancellationSubmitResult.module.css'

type PartialCancellationSubmitStatus = 'success' | 'error'

interface PartialCancellationSubmitResultProps {
  status: PartialCancellationSubmitStatus
}

interface PartialCancellationSubmitResultConfig {
  icon: IconGlyph
  iconClassName: string
  titleKey: string
  messageKey: string
}

const PARTIAL_CANCELLATION_SUBMIT_RESULT_CONFIG: Record<
  PartialCancellationSubmitStatus,
  PartialCancellationSubmitResultConfig
> = {
  success: {
    icon: 'CheckMarkInCircle',
    iconClassName: styles.iconSuccess,
    titleKey: 'booking_details_cancel_booking_partial_cancellation_submit_success_title',
    messageKey: 'booking_details_cancel_booking_partial_cancellation_submit_success_message',
  },
  error: {
    icon: 'InformationInCircle',
    iconClassName: styles.iconError,
    titleKey: 'booking_details_cancel_booking_partial_cancellation_submit_error_title',
    messageKey: 'booking_details_cancel_booking_partial_cancellation_submit_error_message',
  },
}

export function PartialCancellationSubmitResult({ status }: PartialCancellationSubmitResultProps) {
  const { formatMessage } = useIntl()
  const { cancelBookingDialogClosed } = useBookingDetailsActions()
  const config = PARTIAL_CANCELLATION_SUBMIT_RESULT_CONFIG[status]

  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <Icon glyph={config.icon} size={48} className={config.iconClassName} />
        <Typography variant="body-m-bold-snug" as="h2">
          {formatMessage({ id: config.titleKey })}
        </Typography>
        <Typography variant="body-s-regular-snug" as="p">
          {formatMessage({ id: config.messageKey })}
        </Typography>
        <Button className={styles.closeButton} onClick={cancelBookingDialogClosed}>
          {formatMessage({ id: 'close' })}
        </Button>
      </div>
    </div>
  )
}
